module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNWQ5ZDc5Y2ZkMmFiMTA1MTgzMDU5YjRmZDEyNDlmYTkucG5nIjs="